// Animates a number from what is on screen to its new value (ease-out), for KPI values. Jumps
// straight to the value when the viewer prefers reduced motion or the tab is in the background.
import { useEffect, useRef, useState } from 'react';

const reducedMotion = () => typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

export function useCountUp(target: number | null, ms = 700): number | null {
  const [shown, setShown] = useState<number | null>(() => (target === null || reducedMotion() ? target : 0));
  const current = useRef(shown);
  current.current = shown;

  useEffect(() => {
    if (target === null || !Number.isFinite(target) || reducedMotion() || document.hidden) {
      setShown(target);
      return;
    }
    const from = current.current ?? 0;
    if (from === target) return;
    const t0 = performance.now();
    let raf = 0;
    const step = (now: number) => {
      const k = Math.min(1, (now - t0) / ms);
      setShown(k >= 1 ? target : from + (target - from) * (1 - (1 - k) ** 3));
      if (k < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [target, ms]);

  return shown;
}
